{
  "$comment": "Source of truth for TeamForm Segment journey analytics. Mirrored verbatim in teamform-app-ui/src/consts/analyticsManifest.json. Dual-emit always on. PostHog new-model filter: journey_macro is set. No schema_version.",
  "journey_macros": [
    "explore_organisation",
    "org_design",
    "workforce_planning",
    "strategy_alignment",
    "insights_reporting",
    "change_audit",
    "data_flow_automation",
    "admin_configuration",
    "user_onboarding",
    "support_operations"
  ],
  "lifecycle_stages": [
    "viewed",
    "started",
    "submitted",
    "completed",
    "failed",
    "abandoned"
  ],
  "interaction_modes": ["read", "edit"],
  "audience_tiers": ["general", "power", "admin", "support"],
  "required_envelope_keys": [
    "journey_macro",
    "lifecycle_stage",
    "interaction_mode",
    "audience_tier",
    "feature_availability",
    "user_role",
    "person_id",
    "page_path",
    "tenant_id",
    "workspace_id"
  ],
  "path_identity_keys": [
    "entry_point",
    "component_variant",
    "feature_version",
    "operation_intent",
    "allocation_mode"
  ],
  "path_identity_vocab": {
    "entry_point": [
      "org_chart",
      "team_details_actions_menu",
      "team_add_new_modal",
      "forecast_add_new_team_modal",
      "allocation_add_new_modal",
      "team_builder_requestor",
      "tag_badge",
      "tags_tree",
      "tag_details",
      "entity_tag",
      "filter_sidebar",
      "global_search",
      "people_page",
      "teams_page",
      "planner",
      "forecast",
      "admin",
      "workflow",
      "import",
      "api",
      "unknown"
    ],
    "component_variant": [
      "move_group_modal",
      "move_group_enhanced_modal",
      "move_group_enhanced_modal_legacy",
      "forecast_move_group_modal"
    ],
    "feature_version": ["v1", "v2"],
    "operation_intent": [
      "request",
      "approve",
      "create",
      "update",
      "remove",
      "move",
      "hide",
      "add",
      "link",
      "unlink",
      "export",
      "search",
      "import",
      "sync",
      "run",
      "configure",
      "update_name",
      "update_type",
      "update_attributes",
      "update_tag_value",
      "update_entity_tag",
      "change_supply_group",
      "update_fte"
    ],
    "allocation_mode": [
      "membership",
      "individual",
      "individual_realtime",
      "bulk",
      "bulk_realtime",
      "macro"
    ]
  },
  "ambiguous_actions": [
    {
      "id": "team_move",
      "identity_key": "component_variant",
      "values": [
        "move_group_modal",
        "move_group_enhanced_modal",
        "move_group_enhanced_modal_legacy",
        "forecast_move_group_modal"
      ],
      "surfaces": [
        "MoveGroupModal",
        "MoveGroupEnhancedModal",
        "MoveGroupEnhancedModalLegacy",
        "Forecast MoveGroupModal"
      ]
    },
    {
      "id": "team_create",
      "identity_key": "entry_point",
      "values": [
        "team_details_actions_menu",
        "forecast_add_new_team_modal",
        "team_builder_requestor",
        "allocation_add_new_modal",
        "org_chart"
      ],
      "graphql_operations": ["createTeam", "createTeamInAllocation"]
    },
    {
      "id": "planner_request_vs_approve",
      "identity_key": "operation_intent",
      "values": ["request", "approve"],
      "graphql_operations": [
        "requestMacroAllocationAbsolute",
        "approveMacroAllocationAbsolute",
        "submitMacroAllocationRequests",
        "submitMacroAllocationApprovals"
      ]
    },
    {
      "id": "allocate_person",
      "identity_key": "allocation_mode",
      "values": ["membership", "individual", "individual_realtime"],
      "graphql_operations": [
        "addMembership",
        "allocateIndividualAllocation",
        "allocateIndividualRealTime"
      ]
    },
    {
      "id": "update_allocation",
      "identity_key": "operation_intent",
      "values": ["update", "move", "change_supply_group", "update_fte"],
      "graphql_operations": [
        "updateMembership",
        "mutateMemberships",
        "changePersonSupplyGroup",
        "updateFteIndividualAllocation"
      ]
    },
    {
      "id": "unallocate_person",
      "identity_key": "allocation_mode",
      "values": ["membership", "individual", "individual_realtime"],
      "graphql_operations": [
        "removeMembership",
        "unallocateIndividualAllocation",
        "unallocateIndividualRealTime"
      ]
    },
    {
      "id": "tag_add_vs_remove",
      "identity_key": "operation_intent",
      "values": ["add", "remove", "link", "unlink"],
      "graphql_operations": [
        "addTagToEntity",
        "removeTagFromEntity",
        "updateTagsOnEntities"
      ]
    },
    {
      "id": "team_update",
      "identity_key": "operation_intent",
      "values": ["update_name", "update_type", "update_attributes"],
      "graphql_operations": [
        "updateGroupName",
        "updateGroupType",
        "updateTeamAttributes"
      ]
    },
    {
      "id": "tag_update",
      "identity_key": "operation_intent",
      "values": ["update_entity_tag", "update_tag_value"],
      "graphql_operations": ["updateEntityTag", "updateTagValue"]
    },
    {
      "id": "association_add_vs_remove",
      "identity_key": "operation_intent",
      "values": ["add", "remove"],
      "graphql_operations": ["addAssociation", "removeAssociation"]
    },
    {
      "id": "ai_dashboards_version",
      "identity_key": "feature_version",
      "values": ["v1", "v2"],
      "surfaces": ["AIContent", "AIDashboardsV2"]
    }
  ]
}
